export default __webpack_public_path__ + "static/media/pandas.d73175b2.svg";